import { create } from 'zustand'
import { configurePersist } from 'zustand-persist'

import {
    getFilteredAndSearchedJobs,
    getFilteredItems,
    setFilterStateDropdown,
    setFilterStateCheckbox,
    getFilterBubbles,
} from '../Utilities/filterUtility'
import { getSearchConfiguration } from '../Utilities/searchInitializationUtility'

const allJobs = JSON.parse(document.querySelector('.js-jobs-list-string').innerText)
const allFilters = JSON.parse(document.querySelector('.js-jobs-list-filter').innerText)

const { persist } = configurePersist({
    storage: sessionStorage, // use session storage because we don't want to restore the active filters in a new session
})

/**
 * initialize fuse search configuration
 */
const fuse = getSearchConfiguration(allJobs)

export const useJobsStore = create(
    persist(
        {
            key: 'filterStore', // required, child key of storage
            allowlist: ['activeFilterTagUids', 'currentSearchTerm'], // which properties we want to persist
        },
        (set, get) => ({
            allJobs,
            filteredAndSearchedJobs: () => getFilteredAndSearchedJobs(get().searchedJobs(), get().activeFilterTagUids),
            allFilters,
            filterBubbles: () => getFilterBubbles(get().filteredAndSearchedJobs()),
            initiallyAvailableFilters: () => getAvailableFilters([], allJobs),
            activeFilterTagUids: [], // Note this could automatically be filled by the persist layer (from the session storage)
            setFilterState: (filterUid, filterField, isChecked, isDropdownFilter) => {
                let activeFilterTagUids = get().activeFilterTagUids
                if (isDropdownFilter) {
                    activeFilterTagUids = setFilterStateDropdown(activeFilterTagUids, filterField, filterUid)
                } else {
                    activeFilterTagUids = setFilterStateCheckbox(activeFilterTagUids, filterField, filterUid, isChecked)
                }

                const searchedJobs = get().searchedJobs()
                const allFilters = get().allFilters
                set({
                    ...getFilteredItems(searchedJobs, activeFilterTagUids, allFilters),
                    activeFilterTagUids: activeFilterTagUids,
                })
            },
            resetFilterState: () => {
                const allJobs = get().allJobs
                const allFilters = get().allFilters
                set({
                    currentSearchTerm: '',
                    activeFilterTagUids: [],
                    ...getFilteredItems(allJobs, [], allFilters),
                })
            },
            searchedJobs: () =>
                get().currentSearchTerm
                    ? fuse.search(get().currentSearchTerm).map((result) => result.item)
                    : get().allJobs,
            currentSearchTerm: '',
            setCurrentSearchTerm: (searchTerm) => {
                const searchResults = fuse.search(searchTerm)
                const searchedJobs = searchTerm ? searchResults.map((result) => result.item) : get().allJobs
                const allFilters = get().allFilters
                let activeFilterTagUids = get().activeFilterTagUids
                set({
                    ...getFilteredItems(searchedJobs, activeFilterTagUids, allFilters),
                    currentSearchTerm: searchTerm,
                })
            },
        })
    )
)
